import { useParams } from 'react-router-dom';

export const useMipController = () => {
	const { mipId } = useParams();

	return {
		mipId,
	};
};
